export default __webpack_public_path__ + "static/media/20.bcb2130c.jpg";